import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "@atenea-cms";

import { AteneaModule } from "@atenea-cms";
import { EsportsTeamsRoutes } from "./esports-teams.routes";
import { EsportsTeamListComponent } from "./esports-team-list/esports-team-list.component";
import { EsportsTeamFormComponent } from "./esports-team-form/esports-team-form.component";
import { EsportsTeamService, EsportsTeamFormService } from "./shared";

@NgModule({
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    AteneaModule,
    EsportsTeamsRoutes,
  ],
  declarations: [EsportsTeamListComponent, EsportsTeamFormComponent],
  providers: [EsportsTeamService, EsportsTeamFormService],
})
export class EsportsTeamsModule {}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/esports-teams/esports-teams.module.ts